import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import FooterEmail from './FooterEmail';
import PDFViewer from './PDFViewer';

const PaymentGateway = () => {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewURL, setPreviewURL] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [accessToken, setAccessToken] = useState('');
  const [showHistory, setShowHistory] = useState(false);
  const [history, setHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyError, setHistoryError] = useState('');
  const [sortOrder, setSortOrder] = useState(() => localStorage.getItem('sortOrder') || 'desc');
  const [planInfo, setPlanInfo] = useState(null);

  const API_BASE = "https://eyga4mwga4.execute-api.us-east-1.amazonaws.com/prod";
  const UPLOADS_FOLDER = "uploads/";
  const HISTORY_URL = "https://oa5zd3x7jifog5lggl3nulovl40bkunf.lambda-url.us-east-1.on.aws/";
  const PLAN_INFO_URL = "https://2zyff5s6kpf3ur3otnbqellaby0wkoby.lambda-url.us-east-1.on.aws/";


  useEffect(() => {
    localStorage.setItem('sortOrder', sortOrder);
  }, [sortOrder]);

  useEffect(() => {
    const idToken = Cookies.get('idToken');
    const storedAccessToken = Cookies.get('accessToken');

    if (!idToken || !storedAccessToken) {

      navigate('/login');

    } else {

      setAccessToken(storedAccessToken);
    }

  }, [navigate]);

  useEffect(() => {

    const fetchPlanInfo = async () => {

      try {

        const res = await axios.get(
          PLAN_INFO_URL,
          {
            headers: {
              Authorization:
                `Bearer ${accessToken}`,
            },
          }
        );

        setPlanInfo(res.data);

      } catch (err) {

        console.error(
          "Error plan info:",
          err
        );
      }
    };

    if (accessToken) {
      fetchPlanInfo();
    }

  }, [accessToken]);

  

  const slugifyFileName = (fileName) => {
    return fileName
      .toLowerCase()
      .replace(/[^a-z0-9.]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const slugifiedName = slugifyFileName(file.name);
      console.log('Selected file:', slugifiedName, 'Tamaño:', file.size);
      setSelectedFile(new File([file], slugifiedName, { type: file.type }));
      setPreviewURL(URL.createObjectURL(file));
    }
  };

  const uploadMultipartFile = async () => {
    if (!selectedFile) {
      setError('Please select a file.');
      console.log('Error: No file selected.');
      return;
    }
    setLoading(true);
    setError('');

    try {
      const fileName = selectedFile.name;
      const fileKey = `${UPLOADS_FOLDER}${fileName}`;
      const fileSize = selectedFile.size;
      const partSize = 5 * 1024 * 1024;
      const numParts = Math.ceil(fileSize / partSize);

      console.log('Iniciando carga multiparte para:', fileName, 'Tamaño total:', fileSize, 'Partes:', numParts);

      const initResponse = await axios.post(
        `${API_BASE}/start-upload`,
        { fileName },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      const { uploadId, key } = initResponse.data;
      console.log('Respuesta de inicio de carga:', { uploadId, key });
      if (!uploadId || !key) throw new Error('Error al iniciar la carga multiparte.');

      const uploadPromises = [];
      const parts = [];
      for (let i = 0; i < numParts; i++) {
        const start = i * partSize;
        const end = Math.min(start + partSize, fileSize);
        const filePart = selectedFile.slice(start, end);

        const signedUrlResponse = await axios.post(
          `${API_BASE}/upload-part`,
          { uploadId, key, partNumber: i + 1 },
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );
        const { uploadUrl } = signedUrlResponse.data;
        console.log(`Parte ${i + 1} firmada con URL:`, uploadUrl);
        if (!uploadUrl) throw new Error('No se pudo obtener la URL de subida de parte.');

        const uploadPromise = axios.put(uploadUrl, filePart, {
          headers: { 'Content-Type': 'application/octet-stream' },
        });
        uploadPromises.push(uploadPromise);
        const response = await uploadPromise;
        console.log(`Parte ${i + 1} subida con éxito. ETag:`, response.headers.etag);
        parts.push({ PartNumber: i + 1, ETag: response.headers.etag });
      }
      await Promise.all(uploadPromises);

      const completeResponse = await axios.post(
        `${API_BASE}/complete-upload`,
        { uploadId, key, parts },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      if (completeResponse.data?.location) {
        console.log('Archivo subido a S3:', completeResponse.data.location);
        navigate('/extracttextpagelogin', { state: { fileURL: completeResponse.data.location } });
        setSelectedFile(null);
        setPreviewURL('');
      } else {
        throw new Error('Error al completar la carga del archivo.');
      }
    } catch (err) {
      console.error('Error al subir el archivo:', err);
      setError(err.response?.data?.message || err.message || 'Error al subir el archivo.');
    } finally {
      setLoading(false);
    }
  };

  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
      return null;
    }
  };

  const toggleHistory = async () => {
    if (showHistory) {
      console.log('Ocultando historial de archivos.');
      setShowHistory(false);
      return;
    }

    try {
      setHistoryLoading(true);
      setHistoryError('');
      console.log('Loading history...');

      const idToken = Cookies.get('idToken');
      const payload = parseJwt(idToken);
      
      const user_id = payload?.sub;
      console.log(
        'User ID:',
        user_id
      );

      if (!user_id) {
        setHistoryError('Unable to retrieve user ID.');
        return;
      }

      const response = await axios.get(`${HISTORY_URL}?user_id=${encodeURIComponent(user_id)}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });

      const historyData = response.data.historial || [];
      console.log('Respuesta de historial:', response.data);

      setHistory(historyData);
      setShowHistory(true);
    } catch (err) {
      console.error('Error al obtener el historial:', err);
      setHistoryError(err.response?.data?.message || 'No se pudo obtener el historial.');
    } finally {
      setHistoryLoading(false);
    }
  };

  const getDownloadDateObject = (
      item
    ) => {

      if (!item.created_at)
        return null;

      const date =
        new Date(item.created_at);

      return isNaN(date.getTime())
        ? null
        : date;
    };

  const sortHistoryByDate = (data, order) => {
    return [...data].sort((a, b) => {
      const dateA = getDownloadDateObject(a);
      const dateB = getDownloadDateObject(b);

      if (!dateA || !dateB) return 0;
      return order === 'asc' ? dateA - dateB : dateB - dateA;
    });
  };

  const expandHistoryItems = (
    historyList
  ) => {

    return historyList.map(
      (item) => ({

        ...item,

        __downloadDate:
          item.created_at
            ? new Date(
                item.created_at
              )
            : null,
      })
    );
  };

  const getTotalPages = (expandedItems) => {
    return expandedItems.reduce((total, item) => {
      const pages = parseInt(item.extracted_pages, 10);
      return total + (isNaN(pages) ? 0 : pages);
    }, 0);
  };

  const expandedHistory = useMemo(() => {
    const sorted = sortHistoryByDate(history, sortOrder);
    return expandHistoryItems(sorted);
  }, [history, sortOrder]);

  const isTrial =
    planInfo?.plan_type === "TRIAL" &&
    planInfo?.trial_used !== true;

  const isPayPerUse =
    planInfo?.plan_type === "PAY_PER_USE_PAYPAL" &&
    Number(planInfo?.extra_pages || 0) > 0;

  const translatePlanName = (planType) => {

    const plans = {
      "TRIAL": "Trial Plan",

      "Plan Básico (Mensual)":
        "Basic Plan (Monthly)",

      "Plan Básico (Anual)":
        "Basic Plan (Annual)",

      "Plan Avanzado (Mensual)":
        "Professional Plan (Monthly)",

      "Plan Avanzado (Anual)":
        "Professional Plan (Annual)",

      "Plan Empresarial (Mensual)":
        "Business Plan (Monthly)",

      "Plan Empresarial (Anual)":
        "Business Plan (Annual)"
    };

    return plans[planType] || planType;
  };

  return (
    <div className="min-h-screen bg-gray-50 px-6 py-8 md:px-16">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-6 md:p-10 space-y-8">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl font-bold text-gray-800">PDF Text Extraction</h1>
          <button
            onClick={() => navigate('/')}
            className="text-sm text-blue-600 hover:underline"
          >
            Home
          </button>
        </div>

        {planInfo && (

          <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6">

            <h2 className="text-lg font-bold text-blue-900">
              {planInfo.plan_pages > 0
                ? `📦 ${translatePlanName(planInfo.plan_type)}`
                : isPayPerUse
                ? "💳 Paid Pages Available"
                : isTrial
                ? "🎁 Trial Plan"
                : "⚠️ No Pages Available"}
            </h2>

            <div className="mt-2 text-gray-700">

              <p>
                📄 {isPayPerUse ? "Paid Pages" : "Available Pages"}: {
                  (planInfo.plan_pages || 0) +
                  (planInfo.extra_pages || 0)
                }
              </p>

              <p>
                📅 Expires: {
                  planInfo.expires_at
                    ? new Date(
                        Number(planInfo.expires_at)
                      ).toLocaleDateString()
                    : "N/A"
                }
              </p>

              <p>
                ✅ Status: {
                  planInfo.status === "ACTIVE"
                    ? "Active"
                    : planInfo.status
                }
              </p>

            </div>

          </div>
        )}

        {/* Selección de archivo */}
        <section>

          <h2 className="text-xl font-semibold mb-2">1. Select a PDF File</h2>
          <input
            id="pdf-upload"
            type="file"
            accept="application/pdf"
            onChange={handleFileChange}
            className="hidden"
          />

          <div className="flex items-center gap-4">

            <label
              htmlFor="pdf-upload"
              className="
                px-4
                py-2
                bg-blue-600
                text-white
                rounded-full
                cursor-pointer
                hover:bg-blue-700
                transition
              "
            >
              Choose File
            </label>

            <span className="text-gray-600">

              {selectedFile
                ? selectedFile.name
                : "No file selected"}

            </span>

          </div>
          {previewURL && (
            <div className="mt-4">
              <h3 className="font-medium">Preview:</h3>
              <div className="border rounded mt-2 overflow-hidden">
                <PDFViewer pdfUrl={previewURL} />
              </div>
            </div>
          )}
        </section>

        {/* Subida de archivo */}
        <section>
          <h2 className="text-xl font-semibold mb-2">2. Upload File</h2>
          <button
            onClick={uploadMultipartFile}
            disabled={loading}
            className={`w-full py-3 rounded-md text-white font-semibold transition ${
              loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'
            }`}
          >
            {loading ? 'Uploading...' : 'Upload File'}
          </button>
          {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
        </section>

        {/* Historial */}
        <section>
          <h2 className="text-xl font-semibold mb-2">3. View Extraction History</h2>
          <button
            onClick={toggleHistory}
            className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
          >
            {showHistory ? 'Hide History' : 'Show History'}
          </button>
          {historyLoading && <p className="mt-2 text-gray-600">Loading history...</p>}
          {historyError && <p className="mt-2 text-red-600">{historyError}</p>}

          {showHistory && (
            <div className="mt-4 border p-4 rounded-lg max-h-80 overflow-y-auto bg-gray-100">
              {expandedHistory.length === 0 ? (
                <p className="text-gray-500">No files yet.</p>
              ) : (
                <ul className="divide-y divide-gray-300">
                  {expandedHistory.map((item, index) => (
                    <li key={index} className="py-2">
                      <div className="flex justify-between items-center">
                        <span className="font-medium text-gray-700">{
                            item.event_type ===
                            "EXTRACTION"

                              ? item.FileKey

                              : item.event_type ===
                                "PLAN_PURCHASE"

                              ? "📦 Plan Purchase"

                              : item.event_type ===
                                "PAY_PER_PAGE"

                              ? "💳 Pay Per Page Purchase"

                              : item.event_type
                          }</span>
                        <span className="text-sm text-gray-500">
                          {item.__downloadDate?.toLocaleString() || 'No date'}
                        </span>
                      </div>
                      <p className="text-sm text-gray-600">
                        {item.extracted_pages
                          ? Number(item.extracted_pages) === 1
                              ? "1 page extracted"
                              : `${item.extracted_pages} pages extracted`
                          : ""}
                      </p>
                      
                    </li>
                    
                  ))}
                </ul>
              )}
            </div>
            
          )}
        </section>
      </div>
                      <p style={{ marginTop: '10px', fontWeight: 'bold' }}>
                        Total Pages Extracted: {getTotalPages(expandedHistory)}
                      </p>
      <div className="mt-8">
        <FooterEmail />
      </div>
    </div>
  );
};

export default PaymentGateway;